import request from '@/utils/request';
import { PageResult } from '@/api/typing';

export async function set_column_setting_for_person(params: Record<string, any>) {
  return request.post('/sys/set_column_setting_for_person', params);
}
export async function set_column_setting_for_org(params: Record<string, any>) {
  return request.post('/sys/set_column_setting_for_org', params);
}
export async function set_custom_data_by_flag(params: Record<string, any>) {
  return request.post('/sys/set_custom_data_by_flag', params);
}

export async function get_custom_data_by_flag(params: Record<string, any>) {
  return request.post('/sys/get_custom_data_by_flag', params);
}

export async function query_all_custom_data_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/sys/query_all_custom_data_list', params);
}

export async function query_my_column_setting_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/sys/query_my_column_setting_list', params);
}
